export default {
  vnc: {
    connecting: "Свързване…",
    disconnect: "Прекъсване",
    fullscreen: "Цял екран",
    exitFullscreen: "Изход от цял екран",
    status: {
      label: "Статус",
      connecting: "Свързване…",
      connected: "Свързан",
      disconnected: "Прекъснат",
      error: "Грешка при свързване",
    },
    errors: {
      connectionFailed: "Неуспешно свързване към конзолата на устройството.",
    },
  },
  actions: {
    console: "Конзола",
  },
};
